/* eslint-disable no-alert */
import type { EditorPanel, EditorPanelStateChangeCallback } from '../types';
import * as HTMLElementCreator from '../../../../libs/HTML/HTMLElementCreator';
import { BUTTON_STYLE, LABEL_STYLE, SECTION_LABEL_STYLE } from '../../EditorOverlayStyles';
import type { TrayRefillSettings } from '../../../../game/boardMVC/models/tray/TrayRefillRandomizer';
import { validateTrayRefillSettings } from '../../../tray/validateTrayRefillSettings';
import { EMPTY_LEVEL } from '../../../../game/level/EmptyLevel';

export class EditorRefillsPanel implements EditorPanel {
  public readonly element;

  private readonly textArea: HTMLTextAreaElement;

  private stackRefillsValue = '';

  constructor(private readonly onStateUpdate: EditorPanelStateChangeCallback) {
    this.element = HTMLElementCreator.createDiv({
      parentElement: undefined,
      style: {
        color: 'black',
        minWidth: '180px',
        minHeight: '200px',
        marginTop: '10px',
        pointerEvents: 'auto',
      },
    });

    HTMLElementCreator.createLabel({
      parentElement: this.element,
      style: {
        ...LABEL_STYLE,
        ...SECTION_LABEL_STYLE,
      },
      labelText: 'Stack Refills',
    });

    const textArea = HTMLElementCreator.createTextArea({
      parentElement: this.element,
      style: { display: 'block', maxWidth: '190px', maxHeight: '160px', margin: '2px', fontSize: '8px' },
      cols: 40,
      rows: 40,
      autocomplete: 'off',
      autocapitalize: 'off',
      spellcheck: false,
    });

    HTMLElementCreator.createButton({
      parentElement: this.element,
      labelText: 'Submit Refill Edits',
      style: { ...BUTTON_STYLE, marginLeft: '4px', width: '190px', display: 'block' },
      onClick: () => {
        try {
          if (textArea.value === this.stackRefillsValue) {
            alert('Error: field value is unchanged');
          } else {
            const refills = JSON.parse(textArea.value) as TrayRefillSettings[];
            const refillsValid = validateTrayRefillSettings(refills);
            if (!refillsValid) throw new Error('Invalid Json');

            this.onStateUpdate({ refills });
            textArea.value = JSON.stringify(refills, null, 2);
            this.stackRefillsValue = textArea.value;
            alert(`Stack refills JSON updated.`);
          }
        } catch (e) {
          alert(`Error: Stack refills JSON is invalid.
                    JSON should look like ${JSON.stringify(EMPTY_LEVEL.refills, null, 2)}`);
        }
      },
    });

    HTMLElementCreator.createButton({
      parentElement: this.element,
      labelText: 'Revert Refill Edits',
      style: { ...BUTTON_STYLE, marginLeft: '4px', width: '190px', display: 'block' },
      onClick: () => {
        if (textArea.value === this.stackRefillsValue) {
          alert('Nothing to revert.');
        } else {
          textArea.value = this.stackRefillsValue;
          alert('Stack Refills reverted to last valid state.');
        }
      },
    });
    this.textArea = textArea;
  }

  public destroy(): void {
    this.element.remove();
  }

  public focus(): void {
    this.element.style.visibility = 'visible';
  }

  public blur(): void {
    this.element.style.visibility = 'hidden';
  }

  public update(refills: TrayRefillSettings[]): void {
    this.textArea.value = JSON.stringify(refills, null, 2);
    this.stackRefillsValue = this.textArea.value;
  }
}
